// Address comes from the .env files (.env.development for `npm start`,
// .env.production for `npm run build`). Falls back to localhost if unset.
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001/api';

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const error = new Error(data.message || `Request failed: ${res.status}`);
    error.status = res.status;
    throw error;
  }

  return data;
}
